export default Object.freeze({
  'common.language.label': '语言',
  'common.brand.name': 'Happy Pets',
  'common.download.action': '下载',
  'common.store.appleprefix': '下载于',
  'common.store.applename': 'App Store',
  'common.store.googleprefix': '在此获取',
  'common.store.googlename': 'Google Play',
  'seo.home.title': 'Happy Pets｜AI 陪伴、自我探索测评与宠物组件',
  'seo.home.description': '认识会陪你日常反思、探索性格、体验塔罗与运势，并能与好友合养的 AI 宠物伙伴。',
  'seo.home.keywords': 'Happy Pets, AI 陪伴, 虚拟宠物, 宠物组件, 性格测试, MBTI, AI 塔罗',
  'seo.invite.title': 'Happy Pets 邀请｜和好友一起养虚拟宠物',
  'seo.invite.description': '打开 Happy Pets 邀请，在 iPhone 或 Android 上领养或与好友合养虚拟宠物。',
  'nav.skills.label': '宠物技能',
  'nav.tests.label': '测评',
  'nav.guidance.label': 'AI 指引',
  'nav.features.label': '功能',
  'nav.experience.label': '体验方式',
  'nav.community.label': '社区',
  'nav.news.label': '新闻',
  'home.hero.titlelead': '一只小小宠物，',
  'home.hero.titleaccent': '每天帮你一点点',
  'home.hero.subtitle': '领养一只住在屏幕上的温暖虚拟宠物。它会与你一起成长，解锁实用技能，为日常带来帮助、乐趣和轻松陪伴。',
  'home.tools.eyebrow': '宠物技能',
  'home.tools.title': '宠物能帮你完成的日常小事',
  'home.tools.description': '让宠物成为实用的日常伙伴，陪你反思、想菜单、了解性格，并协助做出生活中的小决定。',
  'home.tools.action': '立即体验',
  'tool.tarot.tag': '自我反思',
  'tool.tarot.title': '塔罗牌',
  'tool.tarot.description': '让宠物为你的问题抽一张牌，用轻松的解读陪你换个角度思考当下。',
  'tool.mbti.tag': '性格',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': '让宠物分析你的类型和行为模式，探索你如何思考、表达和与人连接。',
  'tool.chef.tag': '厨房',
  'tool.chef.title': '冰箱厨师',
  'tool.chef.description': '把冰箱里已有的食材变成简单菜谱，让宠物做你聪明的小厨师。',
  'tool.fortune.tag': '每日',
  'tool.fortune.title': '每日运势',
  'tool.fortune.description': '和宠物一起开启一天，看看心情、能量、幸运细节和轻松的小提示。',
  'tool.calorie.tag': '健康',
  'tool.calorie.title': '卡路里计算',
  'tool.calorie.description': '让宠物帮你估算热量、发现营养规律，更轻松地选择每一餐。',
  'tool.dream.tag': '梦境',
  'tool.dream.title': '梦境解读',
  'tool.dream.description': '让宠物解读昨夜梦里的符号，把模糊片段整理成值得反思的主题。',
  'home.assessments.eyebrow': '更了解自己',
  'home.assessments.title': '值得继续探索结果的自我发现测评',
  'home.assessments.description': '完成性格、推理、职业或关系测评，再把结果带回与 AI 宠物的对话中继续探索。',
  'home.assessments.action': '开始测评',
  'home.assessments.disclaimer': '这些测评用于自我探索和娱乐，不能替代医学诊断或专业建议。',
  'assessment.mbti.eyebrow': '性格',
  'assessment.mbti.title': 'MBTI 性格测试',
  'assessment.mbti.description': '通过详细测评探索你的偏好、沟通方式、优势和成长模式。',
  'assessment.mbti.meta': '108 题',
  'assessment.sbti.eyebrow': '社交风格',
  'assessment.sbti.title': 'SBTI 性格测试',
  'assessment.sbti.description': '从情绪、行动和社交能量等五个有趣维度，看看你在人群中的样子。',
  'assessment.sbti.meta': '62 题',
  'assessment.iq.eyebrow': '推理',
  'assessment.iq.title': 'IQ 推理测评',
  'assessment.iq.description': '完成非语言图形题，在结构化的自我探索体验中比较不同推理能力。',
  'assessment.iq.meta': '视觉推理',
  'assessment.holland.eyebrow': '职业',
  'assessment.holland.title': '霍兰德职业兴趣',
  'assessment.holland.description': '从六类兴趣主题中发现更适合你的活动与工作环境。',
  'assessment.holland.meta': '职业兴趣',
  'assessment.attachment.eyebrow': '关系',
  'assessment.attachment.title': '依恋风格测试',
  'assessment.attachment.description': '从亲密、信任、安全感和独立性出发，更好地理解自己的关系模式。',
  'assessment.attachment.meta': '关系洞察',
  'home.guidance.eyebrow': '温柔的每日仪式',
  'home.guidance.title': '以自我反思为核心的 AI 神秘指引',
  'home.guidance.description': 'Happy Pets 用塔罗、每日运势和梦境符号，陪你慢下来、说出感受，并找到可执行的下一小步。重点不是预知未来，而是为今天多一点清晰和安心。',
  'guidance.tarot.title': 'AI 塔罗',
  'guidance.tarot.description': '围绕一个问题选牌，把解读当作温柔提示，帮助你反思、转换视角并迈出下一小步。',
  'guidance.tarot.note': '用于反思与娱乐',
  'guidance.fortune.title': '每日运势',
  'guidance.fortune.description': '从心情、能量、幸运细节和实用鼓励开始新的一天。',
  'guidance.fortune.note': '每天都有新指引',
  'guidance.dream.title': '梦境解读',
  'guidance.dream.description': '把梦里记得的画面和感受整理成可以探索的主题，而不是固定预言。',
  'guidance.dream.note': '符号、感受与反思',
  'home.features.eyebrow': '实用技能，每日快乐',
  'home.features.title': '你的宠物为什么越来越能帮上忙',
  'feature.raise.title': '养育可爱宠物',
  'feature.raise.description': '喂食、玩耍，看着它成长为可爱、治愈又意外实用的伙伴。',
  'feature.hatch.title': '孵化新技能',
  'feature.hatch.description': '收集宠物蛋，发现性格各异、拥有不同日常技能的独特宠物。',
  'feature.coraising.title': '和好友一起养',
  'feature.coraising.description': '邀请好友共同照顾宠物，双倍关爱，双倍快乐。',
  'feature.status.title': '每日状态',
  'feature.status.description': '记录每天的状态，把你的感受告诉宠物。',
  'feature.frequency.title': '每日频率',
  'feature.frequency.description': '创建自己的事件，记录喝水、跑步等事情发生的频率。',
  'feature.cleaner.title': '照片清理',
  'feature.cleaner.description': '边玩边整理相册，有趣又高效。',
  'feature.skills.title': 'AI 技能屋',
  'feature.skills.description': '解锁新造型，发现宠物在反思、规划和日常生活中帮助你的更多方式。',
  'feature.widget.title': '互动组件',
  'feature.widget.description': '把宠物放在主屏幕互动组件中，随时陪在身边。',
  'home.steps.eyebrow': '开始体验',
  'home.steps.title': '孵化一只有实用技能的宠物',
  'step.adopt.title': '领养',
  'step.adopt.description': '选择一颗独特的宠物蛋，开启属于你的陪伴旅程。',
  'step.grow.title': '成长',
  'step.grow.description': '每天喂食、玩耍和互动，帮助宠物成长并解锁更多实用技能。',
  'step.together.title': '一起',
  'step.together.description': '邀请好友，让宠物共享一个充满个性、支持和日常帮助的世界。',
  'home.reviews.eyebrow': '社区',
  'home.reviews.title': '大家喜欢它，不只是因为可爱',
  'home.reviews.role': '宠物家长',
  'home.news.eyebrow': '资讯与故事',
  'home.news.title': '最新资讯',
  'home.news.description': '分享宠物陪伴、自我探索与日常身心健康的温柔灵感。',
  'home.news.readarticle': '阅读文章',
  'home.news.exploreall': '查看全部资讯',
  'review.one.text': '我的宠物很可爱，但更惊喜的是，我真的经常用到它那些日常小技能。',
  'review.two.text': '和男朋友合养宠物给我们带来很多快乐，额外技能也让它每天都很实用。',
  'review.three.text': '互动组件太有意思了。我喜欢主屏幕上有个可爱伙伴，还能帮我处理日常小事。',
  'home.footer.tagline': '把快乐与陪伴带到你的主屏幕。',
  'home.footer.product': '产品',
  'home.footer.support': '支持',
  'home.footer.social': '社交平台',
  'home.footer.skills': '宠物技能',
  'home.footer.features': '功能',
  'home.footer.widgets': '组件',
  'home.footer.help': '帮助中心',
  'home.footer.privacy': '隐私政策',
  'home.footer.harmonyprivacy': '鸿蒙隐私政策',
  'home.footer.terms': '用户协议',
  'home.footer.copyright': '© 2024 Happy Pet。保留所有权利。',
  'home.image.logoalt': 'Happy Pets 标志',
  'home.image.screenalt': 'Happy Pets 应用界面',
  'home.image.enlargedalt': '放大的 Happy Pets 界面',
  'home.image.close': '关闭图片',
  'invite.headline': '好友邀请你一起养宠物，快来加入吧！',
  'invite.description': '接受邀请，宠物蛋立即孵化。还可以把宠物添加到主屏幕。',
  'invite.download': '下载',
  'invite.loadingalt': '正在加载 Happy Pets',
  'invite.screensalt': 'Happy Pets 应用截图'
})
